import { useNavigate } from 'react-router-dom';
import { useTranslation } from 'react-i18next';
import { Package, Radio, Activity } from 'lucide-react';

import { Button } from '@/components/ui/button';
import { Card, CardContent, CardHeader, CardTitle } from '@/components/ui/card';
import { useIndustryTranslation } from '@/hooks/useIndustryTranslation';

export function QuickActions(): JSX.Element {
  const { t } = useTranslation();
  const navigate = useNavigate();
  const addItemLabel = useIndustryTranslation('pages.dashboard.quickActions.addItem');

  const actions = [
    {
      label: addItemLabel,
      icon: Package,
      onClick: () => navigate('/items'),
      color: 'bg-blue-500/10 hover:bg-blue-500/20 text-blue-600 dark:text-blue-500',
    },
    {
      label: t('pages.dashboard.quickActions.addScanner'),
      icon: Radio,
      onClick: () => navigate('/scanners'),
      color: 'bg-purple-500/10 hover:bg-purple-500/20 text-purple-600 dark:text-purple-500',
    },
    {
      label: t('pages.dashboard.quickActions.viewDetections'),
      icon: Activity,
      onClick: () => navigate('/detections'),
      color: 'bg-orange-500/10 hover:bg-orange-500/20 text-orange-600 dark:text-orange-500',
    },
  ];

  return (
    <Card>
      <CardHeader>
        <CardTitle>{t('pages.dashboard.quickActions.title')}</CardTitle>
      </CardHeader>
      <CardContent>
        <div className="grid grid-cols-2 gap-3">
          {actions.map((action) => {
            const Icon = action.icon;
            return (
              <Button
                key={action.label}
                variant="outline"
                className={`h-auto flex-col gap-2 py-4 ${action.color} border-0`}
                onClick={action.onClick}
              >
                <Icon className="h-6 w-6" />
                <span className="text-xs font-medium">{action.label}</span>
              </Button>
            );
          })}
        </div>
      </CardContent>
    </Card>
  );
}
